/**
 * Estimate indexing time from file count.
 *
 * Conservative estimate based on ~5 files/sec (embedding + chunking).
 * Includes 10s overhead for model loading and DB initialization.
 */
export function estimateIndexingTime(fileCount: number): {
  etaSeconds: number;
  etaDisplay: string;
} {
  if (fileCount <= 0) {
    return { etaSeconds: 0, etaDisplay: 'a few seconds' };
  }

  const etaSeconds = Math.ceil(fileCount / 5) + 10;

  return { etaSeconds, etaDisplay: formatDuration(etaSeconds) };
}

function formatDuration(seconds: number): string {
  if (seconds < 60) {
    return `~${String(seconds)} seconds`;
  }
  const minutes = Math.round(seconds / 60);
  if (minutes === 1) {
    return '~1 minute';
  }
  return `~${String(minutes)} minutes`;
}
